import { registerGiftPlugin } from '../../manager'
import shopStore from './store'
import ShopRenderer from './ui/ShopRenderer.vue'

registerGiftPlugin({
  id: 'shop',
  store: shopStore,
  component: ShopRenderer,
  order: 10,
})
